export function formatDescription(s:string)
{
    return s.toLowerCase().replace(/^([a-z])|\s(?!mcc)([a-z])|\.([a-z])|,([a-z])/g, $1 => $1.toUpperCase()).replace(/mcc|Cc|W\/o/g, $1 => $1.toUpperCase());
}